import { useEffect, useRef } from "react";

//#region src/hooks/layout/use-safe-scroll-top.ts
const useSafeScrollTop = (active) => {
	const scrollXRef = useRef(-1);
	const scrollYRef = useRef(-1);
	useEffect(() => {
		if (active) {
			scrollXRef.current = window.scrollX;
			scrollYRef.current = window.scrollY;
			window.scroll({
				top: 0,
				left: 0,
				behavior: "instant"
			});
			return;
		}
		if (scrollXRef.current !== -1 && scrollYRef.current !== -1) {
			window.scroll({
				top: scrollYRef.current,
				left: scrollXRef.current,
				behavior: "instant"
			});
			scrollXRef.current = -1;
			scrollYRef.current = -1;
		}
	}, [active]);
};

//#endregion
export { useSafeScrollTop };